module.exports = __webpack_public_path__ + "static/media/32-iveco-mercedes.20c73c27.jpg";